module.exports = new __parcel__URL__("summary-preview.10045d4f.svg").toString();